import { EditableText } from '@smartfire/components';
import { BlockWrapper, defineBlock, smartProps, useInspectorControl } from '@smartfire/js-block-engine';
import React from 'react';
import Select from './Select';
import style from './block.module.scss';

const Inspector = React.lazy(() => import('./Inspector'));

const Block = ({ question, options, resetFields }) => {
    useInspectorControl(Inspector);

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.top}>
                <EditableText
                    className={style.text}
                    tagName="p"
                    smartProp="question"
                    placeholder="Insérer votre question ..."
                />
            </div>

            <Select options={options} name={question} reset={resetFields} />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block,
    smartProps: {
        question: smartProps.string.withDefault('Question?'),
        options: smartProps.array.withDefault([]),
    },
    setup: {
        title: 'Sélection',
        parent: ['smartfire/quiz-form', 'smartfire/quiz-form---two-columns'],
    },
});
